import { useState, useEffect } from "react";
import { screens } from "./Breakpoints";

export function useIsMobileOrTablet() {
    // Tailwind's `lg` = 1024px
    const query = `(max-width: ${screens.lg - 1}px)`;

    const getMatch = () =>
        typeof window !== "undefined"
            ? window.matchMedia(query).matches
            : false;

    const [isMobileOrTablet, setIsMobileOrTablet] = useState(getMatch);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const media = window.matchMedia(query);
        const listener = (e) => setIsMobileOrTablet(e.matches);

        // Set initial state
        setIsMobileOrTablet(media.matches);

        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }, [query]);

    return isMobileOrTablet;
}